<template>
    <div>
      <br />

      <el-tabs type="border-card" :value="activeTab" @tab-click="onSubtabChange">
         <el-tab-pane name="active" lazy>
           <template #label><span><i class="fa fa-tasks">&nbsp;</i>Active <el-badge v-if="numActive" type="primary" :value="numActive"/></span></template>
           <actions-table type="Active" :row-data="rowData" :edit-mode="editMode" :read-only="readOnly" />
         </el-tab-pane>

         <el-tab-pane name="rejected" lazy>
           <template #label><span><i class="fa fa-exclamation-triangle">&nbsp;</i>Rejected <el-badge v-if="numRejects" type="warning" :value="numRejects"/></span></template>
           <actions-table type="Rejected" :row-data="rowData" :edit-mode="false" />
         </el-tab-pane>

         <el-tab-pane name="closed" lazy>
           <template #label><span><i class="fa fa-flag">&nbsp;</i>Closed <el-badge v-if="numClosed" type="success" :value="numClosed"/></span></template>
           <actions-table type="Closed" :row-data="rowData" :edit-mode="false" :read-only="readOnly" />
         </el-tab-pane>

      </el-tabs>
      <br />
  </div>
</template>

<script>

import ActionsTable from '@/components/actions/ActionsTable'
import { replaceDrawerArgs } from '@/lib/layerNav'
import { parseDrawerPath, hasDrawer } from '@/lib/drawerParser'

const SUBTAB_MAP = {
  active: 'active',
  rejected: 'rejected',
  closed: 'closed'
}

export default {

  components: {
    ActionsTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    subtab: {
      type: String,
      default: null
    }

  },

  computed: {
    activeTab () {
      return SUBTAB_MAP[this.subtab] || 'active'
    },

    numActive: function () {

      if (this.stats) {
        return Number(this.stats.requests) + Number(this.stats.prg)
      }

      return null
    },

    numRejects: function () {
      if (this.stats) {
        return Number(this.stats.rtsRejected) + Number(this.stats.rtuRejected) + Number(this.stats.rtbRejected) + Number(this.stats.rtdRejected)
      }

      return null
    },

    numClosed: function () {
      if (this.stats) {
        return Number(this.stats.rtsClosed) + Number(this.stats.rtuClosed) + Number(this.stats.rtbClosed) + Number(this.stats.rtdClosed)
      }

      return null
    }
  },

  methods: {
    onSubtabChange (tabPane) {
      const slug = Object.keys(SUBTAB_MAP).find(k => SUBTAB_MAP[k] === tabPane.name) || null
      const currentSubtab = this._currentSubtab()
      if ((currentSubtab || null) === (slug || null)) return
      replaceDrawerArgs(this.$router, 'site', { subtab: slug })
    },

    _currentSubtab () {
      const path = this.$route && this.$route.path ? this.$route.path : ''
      const idx = path.indexOf('/d.')
      if (idx !== -1) {
        const stack = parseDrawerPath(path.slice(idx + 1))
        const entry = stack.find(e => e.name === 'site')
        return entry ? (entry.args.subtab || null) : null
      }
      return this.$route && this.$route.params ? (this.$route.params.subtab || null) : null
    },

    syncDefaultSubtab () {
      const path = this.$route && this.$route.path ? this.$route.path : ''
      const inDrawerStack = path.indexOf('/d.') !== -1
      if (inDrawerStack) {
        const stack = parseDrawerPath(path.slice(path.indexOf('/d.') + 1))
        if (hasDrawer(stack, 'site') && !this._currentSubtab()) {
          this.onSubtabChange({ name: this.activeTab })
        }
      }
    }
  },

  mounted () {
    this.$nextTick(this.syncDefaultSubtab)
  },

  data () {
    return {
      stats: this.rowData && this.rowData.stats ? this.rowData.stats : null
    }
  }


}

</script>
